import { useQuery } from "@tanstack/react-query";
import { axiosCompanyInstance } from "src/config/axios";
import { StationModel } from "../types/Station";

export const RQ_STATION_DETAILS_KEY = "STATION_DETAILS_KEY";

export type StationDetailsResponse = StationModel;

export const useStationDetails = (stationId: string) => {
    return useQuery({
        queryKey: [RQ_STATION_DETAILS_KEY, stationId],
        queryFn: async (): Promise<StationDetailsResponse | null> => {
            if (stationId) {
                const res = await axiosCompanyInstance.get(`station/${stationId}`);

                return res?.data;
            }
            return null;
        },
        enabled: false,
    });
};
